// extracted by mini-css-extract-plugin
module.exports = {"localeSwitcherChoices":"LocaleSwitcherDropdown_localeSwitcherChoices__JHh2h","localeSwitcherToggleOpen":"LocaleSwitcherDropdown_localeSwitcherToggleOpen__m3NwE"};